<template>

  <div class="form-icon">

    <div v-if="form.options.icon" class="fa" :class="'fa-' + form.options.icon" style="vertical-align: middle;line-height: 46px; display: block"></div>


    <svg v-else-if="form.options.withReservation" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="-50 -70 590 500" style="enable-background:new 0 0 495 495;" xml:space="preserve">
<g>
	<g>
		<g>
			<path d="M471.5,112h-448C10.542,112,0,122.542,0,135.5v128C0,276.458,10.542,287,23.5,287H224v49h-24.5
				c-12.958,0-23.5,10.542-23.5,23.5v8c0,8.547,6.953,15.5,15.5,15.5h112c8.547,0,15.5-6.953,15.5-15.5v-8
				c0-12.958-10.542-23.5-23.5-23.5H271v-49h200.5c12.958,0,23.5-10.542,23.5-23.5v-128C495,122.542,484.458,112,471.5,112z
				 M295.5,351c4.687,0,8.5,3.813,8.5,8.5v8c0,0.275-0.224,0.5-0.5,0.5h-112c-0.276,0-0.5-0.225-0.5-0.5v-8
				c0-4.687,3.813-8.5,8.5-8.5H295.5z M239,336v-49h17v49H239z M480,263.5c0,4.687-3.813,8.5-8.5,8.5h-448
				c-4.687,0-8.5-3.813-8.5-8.5v-128c0-4.687,3.813-8.5,8.5-8.5h448c4.687,0,8.5,3.813,8.5,8.5V263.5z"/>
			<path d="M79,187.5c0-15.163-12.336-27.5-27.5-27.5h-12c-4.142,0-7.5,3.357-7.5,7.5v64c0,4.143,3.358,7.5,7.5,7.5
				c4.142,0,7.5-3.357,7.5-7.5V215h4.486l13.773,20.66c1.445,2.168,3.823,3.341,6.247,3.341c1.43,0,2.875-0.408,4.153-1.261
				c3.447-2.298,4.378-6.954,2.08-10.4l-11.215-16.824C74.029,205.6,79,197.122,79,187.5z M51.5,200H47v-25h4.5
				c6.893,0,12.5,5.607,12.5,12.5S58.393,200,51.5,200z"/>
			<path d="M303,187.5c0-15.163-12.336-27.5-27.5-27.5h-12c-4.142,0-7.5,3.357-7.5,7.5v64c0,4.143,3.358,7.5,7.5,7.5
				c4.142,0,7.5-3.357,7.5-7.5V215h4.486l13.773,20.66c1.445,2.168,3.823,3.341,6.247,3.341c1.43,0,2.875-0.408,4.153-1.261
				c3.447-2.298,4.378-6.954,2.08-10.4l-11.215-16.824C298.029,205.6,303,197.122,303,187.5z M275.5,200H271v-25h4.5
				c6.893,0,12.5,5.607,12.5,12.5S282.393,200,275.5,200z"/>
			<path d="M127.5,175c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5h-32c-4.142,0-7.5,3.357-7.5,7.5v64c0,4.143,3.358,7.5,7.5,7.5
				h32c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H103v-17h16.5c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H103v-17H127.5z"/>
			<path d="M407.5,175c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5h-32c-4.142,0-7.5,3.357-7.5,7.5v64c0,4.143,3.358,7.5,7.5,7.5
				h32c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H383v-17h16.5c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H383v-17H407.5z"/>
			<path d="M239.5,175c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5h-32c-4.142,0-7.5,3.357-7.5,7.5v64c0,4.143,3.358,7.5,7.5,7.5
				h32c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H215v-17h16.5c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H215v-17H239.5z"/>
			<path d="M168.7,160h-2.4c-12.296,0-22.3,10.004-22.3,22.354c0,8.501,4.724,16.145,12.327,19.945l15.638,7.818
				c2.489,1.245,4.035,3.746,4.035,6.583c0,4.025-3.275,7.3-7.3,7.3h-2.4c-4.025,0-7.3-3.274-7.3-7.3v-1.2
				c0-4.143-3.358-7.5-7.5-7.5c-4.142,0-7.5,3.357-7.5,7.5v1.2c0,12.296,10.003,22.3,22.3,22.3h2.4
				c12.296,0,22.3-10.004,22.3-22.354c0-8.501-4.724-16.145-12.327-19.945l-15.638-7.818c-2.489-1.245-4.035-3.746-4.035-6.583
				c0-4.025,3.275-7.3,7.3-7.3h2.4c4.025,0,7.3,3.274,7.3,7.3v1.2c0,4.143,3.358,7.5,7.5,7.5c4.142,0,7.5-3.357,7.5-7.5v-1.2
				C191,170.004,180.997,160,168.7,160z"/>
			<path d="M353.319,160.224c-4.014-0.998-8.09,1.439-9.095,5.457l-8.724,34.896l-8.724-34.896
				c-1.005-4.018-5.078-6.462-9.095-5.457c-4.019,1.005-6.462,5.077-5.457,9.096l16,64c0.834,3.339,3.834,5.681,7.276,5.681
				c3.442,0,6.441-2.342,7.276-5.681l16-64C359.781,165.301,357.337,161.229,353.319,160.224z"/>
			<path d="M439.5,160h-8c-4.142,0-7.5,3.357-7.5,7.5v64c0,4.143,3.358,7.5,7.5,7.5h8c17.369,0,31.5-14.131,31.5-31.5v-16
				C471,174.131,456.869,160,439.5,160z M456,207.5c0,9.098-7.402,16.5-16.5,16.5H439v-49h0.5c9.098,0,16.5,7.402,16.5,16.5V207.5z"
				/>
		</g>
	</g>
</g>
</svg>

    <svg v-else xmlns="http://www.w3.org/2000/svg" width="20px" height="17px" viewBox="0 0 170 165">
      <path fill-rule="evenodd" stroke="#666666" stroke-width="3px" stroke-linecap="butt"
            stroke-linejoin="miter" fill="none"
            d="M170.500,98.500 L11.500,98.500 C5.977,98.500 1.500,94.023 1.500,88.500 L1.500,71.500 C1.500,65.977 5.977,61.500 11.500,61.500 L170.500,61.500 C176.023,61.500 180.500,65.977 180.500,71.500 L180.500,88.500 C180.500,94.023 176.023,98.500 170.500,98.500 ZM170.500,38.500 L11.500,38.500 C5.977,38.500 1.500,34.023 1.500,28.500 L1.500,11.500 C1.500,5.977 5.977,1.500 11.500,1.500 L170.500,1.500 C176.023,1.500 180.500,5.977 180.500,11.500 L180.500,28.500 C180.500,34.023 176.023,38.500 170.500,38.500 Z"/>

      <path fill-rule="evenodd" fill="#666666"
            d="M10.000,120.000 L65.000,120.000 C70.523,120.000 75.000,124.477 75.000,130.000 L75.000,147.000 C75.000,152.523 70.523,157.000 65.000,157.000 L10.000,157.000 C4.477,157.000 -0.000,152.523 -0.000,147.000 L-0.000,130.000 C-0.000,124.477 4.477,120.000 10.000,120.000 Z"/>
    </svg>


    <el-tooltip v-if="form.hasEmailField" class="item" effect="dark" content="This form sends email to user"
                placement="top-start">
      <span class="email-icon el-icon-message"></span>
    </el-tooltip>

    <el-tooltip v-if="form.options.withSubscription" class="item" effect="dark" content="This form has subscription field"
                placement="top-start">
      <span class="subscription-icon el-icon-success"></span>
    </el-tooltip>

    <el-tooltip v-if="form.hasProtectedField" class="item" effect="dark" content="This form has protected fields"
                placement="top-start">
      <span class="protected-icon"></span>
    </el-tooltip>
  </div>

</template>
<style lang="scss">
  .form-icon {
    border: 1px solid rgba(35, 35, 35, .1);
    border-radius: 100px;
    width: 48px;
    vertical-align: middle;
    height: 48px;
    line-height: 55px;
    text-align: center;
    float: left;
    margin-right: 10px;
    position: relative;

    .email-icon {
      position: absolute;
      top: -5px;
      right: -5px;
      padding: 3px;
      border-radius: 100px;
      color: #409EFF;
    }

    .subscription-icon {
      position: absolute;
      bottom: -4px;
      left: -4px;
      padding: 3px;
      border-radius: 100px;
      color: #409EFF;
    }
  }
</style>
<script>
  export default {
    props: ['form'],
    data() {
      return {
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Icon.vue?07261ba4